export const RISK_ENGLISH = {
  "datox.risk.title": "Risk Register Automation and CRO Dashboard",
  "datox.risk.workspace.subtitle": "Monthly risk review · source evidence, indicators and CRO reporting",
  "datox.risk.workspace.steps": "Review workflow",
  "datox.risk.workspace.stepCount": "Step {{count}} of {{total}}",
  "datox.risk.stepStatus.completed": "Completed",
  "datox.risk.processing.current": "Processing · {{step}}",
  "datox.risk.processing.ready": "Your monthly risk review",
  "datox.risk.processing.readyHint": "Add source files, run the review, then check the results before approval.",
  "datox.risk.files.coverage": "Source coverage",
  "datox.risk.files.automaticHint": "Upload your files together. Source mappings are applied automatically during the review.",
  "datox.risk.files.formatHelp": "Supported files and extraction details",
  "datox.risk.files.busyHint": "Source changes are temporarily paused while this operation finishes. You can still download files and browse the workflow.",
  "datox.risk.files.removeNamed": "Remove {{filename}} from this case",
  "datox.risk.description": "Review monthly source data, calculate eight configurable risk indicators, and prepare a CRO overview and supporting evidence.",
  "datox.risk.context": "Illustrative indicators and configurable internal limits. Optional external sources are reviewed as evidence, not applied automatically as regulatory requirements.",
  "datox.risk.sample": "Synthetic demonstration data; not an institution-specific policy or regulatory submission.",
  "datox.risk.sample.entity": "Example bank entity (synthetic)",
  "datox.risk.reports.description": "Two report entries · one CRO dashboard with six tabs",
  "datox.risk.setup.entity": "Reporting entity",
  "datox.risk.setup.year": "Reporting year",
  "datox.risk.setup.month": "Reporting month",
  "datox.risk.setup.scope": "Reporting scope",
  "datox.risk.setup.internalVersion": "Internal appetite version",
  "datox.risk.setup.name": "Indicator",
  "datox.risk.setup.metric": "Source metric column",
  "datox.risk.setup.source": "Source / risk area",
  "datox.risk.setup.calculation": "Calculation",
  "datox.risk.setup.ratio": "Ratio of summed fields (%)",
  "datox.risk.setup.sum": "Sum of metric",
  "datox.risk.setup.denominator": "Denominator column (for ratios)",
  "datox.risk.setup.denominatorSource": "Denominator risk source",
  "datox.risk.setup.direction": "Limit direction",
  "datox.risk.setup.upper": "Upper limit",
  "datox.risk.setup.lower": "Lower limit",
  "datox.risk.setup.internalLimit": "Internal appetite limit",
  "datox.risk.setup.references": "External sources (optional)",
  "datox.risk.setup.referencesHint": "Add a public HTTPS URL and tell the agent what to check. Observations are quoted for human review; they do not set compliance limits automatically.",
  "datox.risk.setup.referenceUrl": "Source URL (HTTPS)",
  "datox.risk.setup.referenceUrlPlaceholder": "https://example.org/risk-guidance",
  "datox.risk.setup.referenceInstructions": "What should the agent fetch or check?",
  "datox.risk.setup.referenceInstructionsPlaceholder": "Summarise requirements relevant to the configured indicators and cite the supporting passage.",
  "datox.risk.setup.referenceAdd": "Add another URL and instruction",
  "datox.risk.setup.referenceRemove": "Remove source",
  "datox.risk.setup.referenceIncomplete": "Each external source needs an HTTPS URL and instructions before saving.",
  "datox.risk.setup.save": "Save scope and rules",
  "datox.risk.step.setup": "Period & scope",
  "datox.risk.step.documents": "Source files",
  "datox.risk.step.extract": "Extract & organise",
  "datox.risk.step.validate": "Validate & reconcile",
  "datox.risk.step.indicators": "Limits & indicators",
  "datox.risk.step.register": "Risk register",
  "datox.risk.step.dashboards": "CRO dashboard",
  "datox.risk.step.publish": "Approve & archive",
  "datox.risk.source.loan": "Loan portfolio",
  "datox.risk.source.treasury": "Treasury",
  "datox.risk.source.capital": "Capital",
  "datox.risk.source.counterparty": "Counterparty",
  "datox.risk.source.operational": "Operational risk",
  "datox.risk.source.unassigned": "Unclassified source",
  "datox.risk.create": "Start risk review",
  "datox.risk.open": "Open monthly risk case",
  "datox.risk.back": "All workflows",
  "datox.risk.processing.run": "Run monthly risk review",
  "datox.risk.processing.active": "Risk review is running. Completed stages are saved.",
  "datox.risk.processing.progress": "{{count}} of 6 processing stages saved",
  "datox.risk.processing.failed": "Processing paused at a saved stage. You can retry without uploading files again.",
  "datox.risk.files.upload": "Upload CSV or XLSX",
  "datox.risk.files.replace": "Replace source",
  "datox.risk.files.choose": "Choose uploaded source",
  "datox.risk.files.missing": "Missing",
  "datox.risk.files.received": "Received",
  "datox.risk.files.outdated": "Outdated reporting period",
  "datox.risk.files.download": "Download source",
  "datox.risk.files.dropTitle": "Drop source files here",
  "datox.risk.files.dropHint": "Upload several files at once, in any format. CSV, XLSX and labelled text documents can provide values for calculations; other files remain supporting evidence. Review uncertain source categories below.",
  "datox.risk.files.chooseMany": "Choose files",
  "datox.risk.files.mappedCount": "Mapped risk sources: {{count}} / 5",
  "datox.risk.files.none": "No source files yet. Drop files here or choose them from your device.",
  "datox.risk.files.mapped": "Mapped to {{area}}",
  "datox.risk.files.unmapped": "Category needs review",
  "datox.risk.files.supporting": "Supporting evidence",
  "datox.risk.files.category": "Risk category",
  "datox.risk.files.categoryFor": "Risk category for {{filename}}",
  "datox.risk.files.attach": "Attach to this case",
  "datox.risk.files.remove": "Remove from this case",
  "datox.risk.extraction.empty": "Run the monthly review to see mapped source data and uncertainties.",
  "datox.risk.extraction.rowCount": "Rows: {{count}}",
  "datox.risk.extraction.id": "Record ID",
  "datox.risk.extraction.period": "Reporting period",
  "datox.risk.extraction.classification": "Classification",
  "datox.risk.extraction.source": "Source document and row",
  "datox.risk.extraction.sourceRow": "{{filename}} · row {{row}}",
  "datox.risk.extraction.sourceSheetRow": "{{filename}} · sheet {{sheet}} · row {{row}}",
  "datox.risk.extraction.unavailable": "Source unavailable",
  "datox.risk.extraction.showing": "Showing the first {{shown}} of {{total}} rows",
  "datox.risk.extraction.mappingIssues": "Source data needs attention",
  "datox.risk.extraction.noRows": "No extracted rows for this source. Check the uploaded data and reporting period.",
  "datox.risk.exceptions.empty": "No exceptions recorded for the available source rows.",
  "datox.risk.exception.owner": "Owner",
  "datox.risk.exception.row": "Source row",
  "datox.risk.indicator.current": "Current",
  "datox.risk.indicator.previous": "Previous",
  "datox.risk.indicator.movement": "Movement",
  "datox.risk.indicator.headroom": "Headroom",
  "datox.risk.indicator.external": "External reference review",
  "datox.risk.indicator.status.review_required": "Requires human review",
  "datox.risk.indicator.internal": "Internal appetite",
  "datox.risk.indicator.unassessed": "Not assessed",
  "datox.risk.register.owner": "Risk owner",
  "datox.risk.register.controls": "Controls / mitigants",
  "datox.risk.register.reviewDate": "Next review date",
  "datox.risk.register.action": "Remediation status",
  "datox.risk.register.notes": "Management explanation",
  "datox.risk.register.save": "Save risk ownership and actions",
  "datox.risk.register.resolutionHint": "Risks with outstanding exceptions cannot be marked resolved until source evidence is corrected and the review is rerun.",
  "datox.risk.dashboard.cro": "CRO overview",
  "datox.risk.dashboard.tabs": "CRO overview · Loan · Treasury · Capital · Counterparty · Operational risk",
  "datox.risk.dashboard.legacyHint": "This case has dashboards from an earlier version. Combine them into one dashboard with six tabs without rerunning the risk review.",
  "datox.risk.dashboard.consolidate": "Consolidate dashboards",
  "datox.risk.dashboard.open": "Open dashboard",
  "datox.risk.report.management": "CRO Management Report",
  "datox.risk.report.regulatory": "Regulatory Monitoring and Supporting Evidence",
  "datox.risk.report.open": "Open report",
  "datox.risk.approval.hint": "Review both report entries, request email approvals if needed, then record the management decision. A regulatory submission requires separately verified requirements.",
  "datox.risk.references.title": "External source observations",
  "datox.risk.references.status.review_required": "Review quoted observations",
  "datox.risk.references.status.unavailable": "Unable to review automatically",
  "datox.risk.references.status.not_assessed": "No supported observation",
  "datox.risk.references.instructions": "Requested check",
  "datox.risk.references.observation": "Agent observation — confirm against the source",
  "datox.risk.approval.approve": "Approve monthly review",
  "datox.risk.approval.reject": "Reject",
  "datox.risk.approval.changes": "Request changes",
  "datox.risk.approval.comments": "Decision and management explanation",
  "datox.risk.history.title": "Monthly decision history",
  "datox.risk.history.empty": "No earlier monthly reviews for this entity.",
  "datox.risk.history.reports": "{{count}} report entries",
  "datox.risk.history.open": "Open period review",
  "datox.risk.status.setup": "Setup",
  "datox.risk.status.processing": "Processing",
  "datox.risk.status.processing_failed": "Processing paused",
  "datox.risk.status.needs_recheck": "Needs recheck",
  "datox.risk.status.ready_for_review": "Ready for review",
  "datox.risk.status.needs_information": "Needs information",
  "datox.risk.status.completed": "Approved and archived",
  "datox.risk.status.rejected": "Rejected",
  "datox.risk.status.pending": "Not started",
  "datox.risk.status.needs_review": "Review needed",
  "datox.risk.status.blocked": "Needs attention",
  "datox.risk.status.queued": "Queued",
  "datox.risk.error": "The risk case could not be updated. Reload and try again.",
  "datox.risk.saveFirst": "Save the current step before opening another step. Your changes are still here.",
  "datox.risk.error.validation": "Check the indicator fields, ratio denominators, numeric limits, column mappings, and external URLs and instructions before saving.",
  "datox.risk.error.conflict": "This risk case changed in another session. Reload it before saving again.",
  "datox.risk.error.refresh": "Your action was saved, but the latest data could not be refreshed. Reload to see it.",
  "datox.risk.error.file": "The source document could not be downloaded. Try again.",
  "datox.risk.reload": "Reload case",
  "datox.risk.saving": "Saving…",
  "datox.risk.unassigned": "Unassigned",
  "datox.risk.register.status.open": "Open",
  "datox.risk.register.status.in_progress": "In progress",
  "datox.risk.register.status.resolved": "Resolved",
  "datox.risk.register.status.monitoring": "Monitoring",
  "datox.risk.register.status.attention": "Needs attention",
  "datox.risk.indicator.status.within_limit": "Within referenced limit",
  "datox.risk.indicator.status.breach": "Limit breached",
  "datox.risk.indicator.status.not_assessed": "Not assessed",
} as const
